import { render, staticRenderFns } from "./PayBoxDataTab.vue?vue&type=template&id=274481a1&scoped=true&"
import script from "./PayBoxDataTab.vue?vue&type=script&lang=js&"
export * from "./PayBoxDataTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274481a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('274481a1')) {
      api.createRecord('274481a1', component.options)
    } else {
      api.reload('274481a1', component.options)
    }
    module.hot.accept("./PayBoxDataTab.vue?vue&type=template&id=274481a1&scoped=true&", function () {
      api.rerender('274481a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box-configuration/components/PayBoxDataTab.vue"
export default component.exports